import { useCallback } from 'react';
import { ComponentType } from '@wix/dev-center-client';
import type { LooseAppManifest } from '@wix/cli-app-manifest';
import { BACKEND_WORKER_COMPONENT_ID } from '@wix/cli-astro-definitions';

export function useUpdateManifest() {
  const updateManifestWithBackendWorker = useCallback(
    (
      manifest: LooseAppManifest,
      deploymentId: string,
      deploymentUrl: string,
      label?: string,
      commitHash?: string
    ) => {
      const clone = structuredClone(manifest);
      clone.components.push({
        compId: BACKEND_WORKER_COMPONENT_ID,
        compType: ComponentType.BACKEND_WORKER,
        compData: {
          backendWorker: {
            deploymentId,
            deploymentUrl,
            label,
            commitHash,
          },
        },
      });

      return clone;
    },
    []
  );

  return {
    updateManifestWithBackendWorker,
  };
}
